<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">
    <slot />
    <path
      :fill="color"
      d="M8 17c-.62 0-2-.38-2-1H5c0 1.241 1.76 2 3 2s3-.759 3-2h-1c0 .62-1.38 1-2 1zm7.478-4.928c-.999-.96-1.763-1.964-1.763-5.369 0-2.87-2.263-5.42-5.144-5.703V.577C8.571.258 8.316 0 8 0c-.316 0-.572.258-.572.577V1c-2.88.283-5.144 2.833-5.144 5.703 0 3.405-.764 4.41-1.762 5.37-.5.479-.657 1.204-.402 1.847.26.656.886 1.08 1.594 1.08h12.571c.709 0 1.335-.424 1.595-1.08.254-.643.097-1.368-.402-1.848zM14.416 14H1.584c-.52 0-.778-.618-.413-.975 1.27-1.245 2.161-2.638 2.161-6.453C3.332 4.045 5.42 2 8 2s4.668 2.045 4.668 4.571c0 3.8.882 5.202 2.161 6.453.367.36.104.976-.413.976z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
